import { useEffect, useState } from "react";
import { z } from "zod";
import { toast } from "sonner";
import { fetchFastApi } from "../api/fastapi";

const WorkStepFilterOptionsSchema = z.object({
  sections: z.array(z.string()).default([]),
  subsections: z.array(z.string()).default([]),
  preparers: z.array(z.string()).default([]),
  configuredStates: z.array(z.string()).default([]),
  opsAudits: z
    .array(z.object({ id: z.string(), name: z.string() }))
    .default([]),
});

export type WorkStepFilterOptions = z.infer<typeof WorkStepFilterOptionsSchema>;

/** Filter options for the work steps list. */
export const useWorkStepFilterOptions = () => {
  const [filterOptions, setFilterOptions] =
    useState<WorkStepFilterOptions | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const response = await fetchFastApi({
          path: "/work-steps/filter-options",
          method: "GET",
        });
        if (cancelled) return;
        setFilterOptions(
          WorkStepFilterOptionsSchema.parse(response.filterOptions),
        );
      } catch (error) {
        console.error("Failed to fetch work step filter options:", error);
        toast.error("Failed to fetch work step filter options");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { filterOptions, loading };
};
